import type { TimelineActivity } from '@/types/TimelineActivity'

export const TimelineActivityModel = {
  /**
   * Creates a new timeline activity with default values
   */
  create(data: Partial<TimelineActivity> = {}): TimelineActivity {
    const now = new Date()
    return {
      // Do NOT set an id by default; let Firestore generate it on add
      type: 'comment',
      title: '',
      description: '',
      createdAt: now,
      entityId: '',
      entityType: '',
      ...data,
    }
  },

  /**
   * Validates a timeline activity
   */
  validate(activity: TimelineActivity): boolean {
    if (!activity.type) return false
    if (!activity.title) return false
    if (!activity.entityId) return false
    if (!activity.entityType) return false
    return true
  },

  /**
   * Formats activity for display
   */
  formatActivity(activity: TimelineActivity): string {
    return `${activity.title}${activity.description ? ': ' + activity.description : ''}`
  },
}
